import React from 'react';

const JS_RegExp = () => {
  return (
    <div >
      <h1>JS_RegExp</h1>
      <p>Placeholder component for: "JS RegExp"</p>
    </div>
  );
};

export default JS_RegExp;
